import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ProductSearchService} from '../../service/product-search.service';
import {CategorySearchService} from '../../service/category-search.service';
import {IProduct, IRoom} from '../../model/room.model';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'app-live-products',
    templateUrl: './live-products.component.html',
    styleUrls: ['./live-products.component.scss']
})
export class LiveProductsComponent implements OnInit, OnChanges {
    @Input()
    priceColumn = false;

    @Input()
    selectedIProduct: IProduct;

    @Input()
    deleteColumn = false;

    @Input()
    room: IRoom;

    @Input()
    addButton = false;

    @Input()
    products: IProduct[];

    @Input()
    addRadio: boolean;

    @Output()
    productsChange = new EventEmitter<IProduct[]>();

    @Output()
    productsAdded = new EventEmitter<IProduct[]>();

    @Output()
    productsRemoved = new EventEmitter<string>();

    @Output()
    selectedProduct = new EventEmitter<IProduct>();

    displayModal = false;
    searchProductKeyword: string;
    searchedProducts: IProduct[] = [];
    page = 0;
    itemPerPage = 20;
    totalRecords: any;
    categories: any;
    selectedCatagories: any[] = [];
    selectedProducts: IProduct[] = [];
    selectedProductIds: string[] = [];
    private projectId: string;

    constructor(private productSearchService: ProductSearchService,
                private categorySearchService: CategorySearchService,
                private route: ActivatedRoute) {
        this.projectId = this.route.snapshot.paramMap.get('id');
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.room) {
            this.loadProductAdapter();
        }
    }

    openModal(): void {
        this.displayModal = true;
        this.selectedCatagories = [];
    }

    search(): void {
        this.page = 0;
        this.loadProductAdapter();
    }

    loadProductAdapter(): void {
        this.productSearchService.search(this.searchProductKeyword, this.selectedCatagories, this.room, this.page, this.itemPerPage)
            .subscribe(response => {
                this.totalRecords = response.headers.get('X-Total-Count');
                this.searchedProducts = response.body;
            });
    }

    toggleProduct(product: IProduct): void {
        if (this.selectedProducts.find(selected => selected.id === product.id)) {
            this.selectedProducts = this.selectedProducts.filter(selected => selected.id !== product.id);
            this.selectedProductIds = this.selectedProductIds.filter(selectedId => selectedId !== product.id);
        } else {
            this.selectedProducts.push(product);
            this.selectedProductIds.push(product.id);
        }
    }

    isSelected(id): boolean {
        return !!this.selectedProductIds.find(selected => selected === id);
    }

    addProduct(): void {
        this.productsAdded.emit(this.selectedProducts);
        this.products.push(...this.selectedProducts);
        this.productsChange.emit(this.products);
    }

    removeProduct(product: IProduct): void {
        this.products = this.products.filter(item => item.id !== product.id);
        this.productsRemoved.emit(product.id);
        this.productsChange.emit(this.products);
    }

    onHide(): void {
        this.searchedProducts = [];
        this.searchProductKeyword = '';
        this.selectedProducts = [];
        this.selectedProductIds = [];
    }

    onRowSelect(event): void {
        this.selectedProduct.emit(event.data);
    }

    setCategory(event: any): void {
        this.selectedCatagories.push(event.value);
        this.loadProductAdapter();
    }

    removeCategory(event: any): void {
        const index = this.selectedCatagories.indexOf(event.value);
        if (index > -1) {
            this.selectedCatagories.splice(index, 1);
        }
        this.loadProductAdapter();
    }

    loadProducts(event): void {
        this.page = event.page;
        this.itemPerPage = event.rows;
        this.loadProductAdapter();
    }
}
